import React from 'react';
import { FaTimes } from 'react-icons/fa';
import {
  formatBookingDate,
  getMainTenantStatus,
  getTenantDisplayName,
} from '../tenantHelpers';

const ReleaseTenantModal = ({ tenant, isOpen, onClose, onConfirm, isSaving, error }) => {
  if (!isOpen || !tenant) return null;

  const status = getMainTenantStatus(tenant);
  const isFaulted = status === 'Faulted';
  const booking = tenant.currentBooking || {};
  const bookedBy = booking.bookedUserName || booking.bookedBy;
  const customer = booking.customerName || booking.customer;

  return (
    <div className="stm-modal-overlay" onClick={onClose}>
      <div className="stm-modal stm-modal--sm" onClick={(event) => event.stopPropagation()}>
        <header className="stm-modal__header">
          <div>
            <h2>
              {isFaulted
                ? `Release faulted ${getTenantDisplayName(tenant)}?`
                : `Release ${getTenantDisplayName(tenant)}?`}
            </h2>
          </div>
          <button type="button" className="stm-icon-btn" onClick={onClose} disabled={isSaving} aria-label="Close">
            <FaTimes />
          </button>
        </header>
        <div className="stm-modal__body">
          <p className="stm-modal__text">
            {isFaulted
              ? 'This will end the current booking for this faulted tenant.'
              : 'This will end the current booking and release the tenant from the user.'}
          </p>
          {(bookedBy || customer || booking.bookingEndTime) && (
            <dl className="stm-release-context">
              {bookedBy && (
                <>
                  <dt>Booked by</dt>
                  <dd>{bookedBy}</dd>
                </>
              )}
              {customer && (
                <>
                  <dt>Customer</dt>
                  <dd>{customer}</dd>
                </>
              )}
              {booking.bookingEndTime && (
                <>
                  <dt>Booking end time</dt>
                  <dd>{formatBookingDate(booking.bookingEndTime)}</dd>
                </>
              )}
            </dl>
          )}
          {error && <p className="stm-field-error">{error}</p>}
        </div>
        <footer className="stm-modal__footer">
          <button type="button" className="stm-btn stm-btn--secondary" onClick={onClose} disabled={isSaving}>
            Cancel
          </button>
          <button type="button" className="stm-btn stm-btn--primary" disabled={isSaving} onClick={onConfirm}>
            {isSaving ? 'Releasing...' : 'Release Tenant'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default ReleaseTenantModal;
